import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import './i18n';

import Add from './pages/afterwork/add/Add';
import Edit, { loader as editGroupLoader } from './pages/afterwork/edit/Edit';
import { default as AfterworkHome } from './pages/afterwork/home/Home';
import { default as AfterworkRoot } from './pages/afterwork/root/Root';
import Error from './pages/error/Error';
import Home from './pages/home/Home';
import Login, { action as loginAction } from './pages/login/Login';
import Root from './pages/root/Root';
import Fietstocht from './pages/fietstocht/Fietstocht';

import store from './store/index';

import './index.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <Error />,
    children: [
      {
        path: 'afterwork',
        element: <AfterworkRoot />,
        children: [
          {
            path: '',
            element: <AfterworkHome />,
          },
          {
            path: 'add',
            element: <Add />,
          },
          {
            path: 'edit/:groupId',
            element: <Edit />,
            loader: editGroupLoader,
          },
        ],
      },
      {
        path: 'fietstocht',
        element: <Fietstocht />,
      },
      {
        path: '',
        element: <Home />,
      },
      {
        path: 'login',
        element: <Login />,
        action: loginAction,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);
